<template>
  <div>
    <CCard class="bg-style2" v-if="isCard">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"><CIcon :name="icon" size="lg"/> {{ caption }}</span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <ul class="timeline" id="timeline">
              <li class="li" :class="(objs.complete === true)?'complete':''" v-for="objs in item">
                <div class="timestamp">
                  <span class="author" v-if="!(objs.author === '')">{{ objs.author }}</span>
                  <span class="date" v-if="!(objs.date === '')">{{ objs.date }}</span>
                </div>
                <div class="status" v-if="!(objs.state === '')"  >
                  <samp> {{objs.state}} </samp>
                </div>
              </li>
            </ul>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CRow v-if="!isCard" class="mb-4">
      <CCol>
        <div style="width: 100px; height: 100px; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-align: center;" class="font-weight-bold text-white bg-gradient-success">
          Assessment  <br>
          Porgress
        </div>
      </CCol>
      <CCol col="10">
        <div class="overflow-auto">
        <ul class="timeline" id="timeline">
          <li class="li" :class="(objs.complete === true)?'complete':''" v-for="objs in item">
            <div class="timestamp">
              <span class="author" v-if="!(objs.author === '')">{{ objs.author }}</span>
              <span class="date" v-if="!(objs.date === '')">{{ objs.date }}</span>
            </div>
            <div class="status" v-if="!(objs.state === '')"  >
              <samp> {{objs.state}} </samp>
            </div>
          </li>
        </ul>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>


import {mapGetters} from 'vuex'
export default {
  name: 'Timeline',
  props: {
    caption: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: "cil-layers"
    },
    isCard: {
      type: Boolean,
      default: false
    },
    item:{
      type:Array,
      default: () => [
        {author :"เริ่มกระบวยการ", date : "Core Competency", state : " ", complete: true},
        {author :"พนักงานจัดทำ", date : "แบบประเมิน", state : " ", complete: true},
        {author :"ผู้บังคับบัญชา", date : "ของผู้บังคับบัญชา", state : " ", complete: true},
        {author :"สิ้นสุดกระบวนการพัฒนา", date : "สิ้นสุดกระบวนการ", state : " ", complete: false}
      ]
    }
  },
  data: function () {
    return {

    }
  },

  mounted () {
  },

  created () {
    this.onInit()

  },

  beforeDestroy () {

  },

  methods: {
    onInit(){
      this.onLoad();
    },





  },



  computed:{
    ...mapGetters({
      lang : "setting/lang",

    }),
  },

  watch: {

  }

}
</script>
<style >
</style>


